<div class="modal-header">
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.close(result)">
        <span aria-hidden="true">&times;</span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="mainImg">
    <img src="{{src}}" alt="background image">
</div>